export const MENU_RECIPE_LIST_ID = 'menu-recipe-list'
export const MENU_MAIN_CONTENT_ID = 'menu-main-content'
export const MENU_COLLECTIONS_ID = MENU_MAIN_CONTENT_ID
export const MENU_CONTAINER_ID = 'menu-container'
export const MENU_BOX_SUMMARY_ID = 'menu-box-summary'
export const MENU_RECIPE_LIST_SKIP_TARGET_ID = MENU_RECIPE_LIST_ID
